<template>
    <div class="help-view">
        <div  class="help-banner">
			<p style="font-size: 42px;color: #FFFFFF;margin: 0px;margin-left: 772px;padding-top: 70px;">请问遇到什么问题?</p>
			<div style="border: 1px solid rgba(142,155,169,0.5);width: 880px;height: 56px;border-radius: 6px;margin-left: 520px;background-color: #FFFFFF;margin-top: 53px;">
				<img style="margin-left: 27px;margin-top: 20px;    transform: translateY(3px);"  src="../assets/help/serach.png"/>
				<input v-model="keyword" @keyup.enter="helpdo"  style="border: 1px solid white; width: 70%;height: 40px;margin-left: 12px;" placeholder="输入问题关键词，如:超管转让、解散项目部"/>
			</div>
		</div>
		<div style="margin-top: 73px;"></div>
		<div style="margin-left: 360px;;width: 1300px;min-height:600px">
			<div style="width:411px;height: 279px;float: left;"  v-for="item in list" :key="item.id">
				<div>
					<img :src="item.icon" style="width: 26px;height: 26px;transform: translateY(5px);"/>
					<span style="font-weight: bold;font-size: 20px;color: #333333;margin-left: 15px;" class="cursor" @click="activeId=item.id;helpdo()">{{item.name}}</span>
				</div>
				<div >
					<p style="color: #666666;" v-for="item2 in item.article_list.slice(0, 3)" :key="item2.id" class="cursor" @click="activeId=item2.type;cactiveId=item2.id;helpdo()">· {{item2.title}}</p>
					<p style="color: #007BD3;" @click="activeId=item.id;helpdo()" class="cursor" v-if="item.article_list.length>3">查看更多 > </p>
				</div>
			</div>
		</div>
	
    </div>
</template>
<script>
export default {
    name: 'HelpView',
    data() {
        return {
			activeId:0,
			cactiveId:0,
            logo: require('@/assets/help/banner5.png'),
			keyword:"",
			list:[
				// {
				// 	icon:require('@/assets/help/banner5.png'),
				// 	name:"注册与登录", 
				// 	article_list:[
				// 		{
				// 			title:"如何注册纳软账号"
				// 		},{
				// 			title:"客户端通用设置功能相关介绍"
				// 		}, 
				// 	]
				// },{
				// 	icon:require('@/assets/help/banner5.png'),
				// 	name:"注册与登录", 
				// 	article_list:[
				// 		{
				// 			title:"如何注册纳软账号"
				// 		},{
				// 			title:"客户端通用设置功能相关介绍"
				// 		}, 
				// 	]
				// },{
				// 	icon:require('@/assets/help/banner5.png'),
				// 	name:"注册与登录", 
				// 	article_list:[
				// 		{
				// 			title:"如何注册纳软账号"
				// 		},{
				// 			title:"客户端通用设置功能相关介绍"
				// 		}, 
				// 	]
				// },{
				// 	icon:require('@/assets/help/banner5.png'),
				// 	name:"注册与登录", 
				// 	article_list:[
				// 		{
				// 			title:"如何注册纳软账号"
				// 		},{
				// 			title:"客户端通用设置功能相关介绍"
				// 		}, 
				// 	]
				// },
			]
            
        }
    },
    async mounted() {
		this.helpList();
    },
    methods: {
		async helpList() {
			const response = await fetch(this.$apiBaseUrl+"/api/website/help_list");
			const data = await response.json();
			this.list=data.data;
		},
		helpdo(){
			this.$router.push("/helpdo?keyword="+this.keyword+"&activeId="+this.activeId+"&cactiveId="+this.cactiveId);			
		}
    }
}
</script>
<style lang="scss" scoped>
.help-view {
	.cursor{
		cursor:pointer
	}
	.cursor:hover{
		color: #007BD3 !important;
	}
	
	.help-banner{
		height: 208px;
		background-image: url('../assets/help/banner5.png')
		
	}
	input:focus {
      outline: none;
      border: none;
	}

	
}
</style>